var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 9.16699H6.66671M8.33337 12.5003H6.66671M13.3334 5.83366H6.66671M16.6667 8.75033V5.66699C16.6667 4.26686 16.6667 3.5668 16.3942 3.03202C16.1545 2.56161 15.7721 2.17916 15.3017 1.93948C14.7669 1.66699 14.0668 1.66699 12.6667 1.66699H7.33337C5.93324 1.66699 5.23318 1.66699 4.6984 1.93948C4.22799 2.17916 3.84554 2.56161 3.60586 3.03202C3.33337 3.5668 3.33337 4.26686 3.33337 5.66699V14.3337C3.33337 15.7338 3.33337 16.4339 3.60586 16.9686C3.84554 17.439 4.22799 17.8215 4.6984 18.0612C5.23318 18.3337 5.93324 18.3337 7.33337 18.3337H9.58337M18.3334 18.3337L17.0834 17.0837M17.9167 15.0003C17.9167 16.6112 16.6109 17.917 15 17.917C13.3892 17.917 12.0834 16.6112 12.0834 15.0003C12.0834 13.3895 13.3892 12.0837 15 12.0837C16.6109 12.0837 17.9167 13.3895 17.9167 15.0003Z",
    stroke: "#278DEC",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentSearch);
export default __webpack_public_path__ + "static/media/documentSearch.6df387734a5b5c6cbcaa3731fefc8541.svg";
export { ForwardRef as ReactComponent };